// @flow

// Hocs
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

// Module
import { toggleMenu, activeRoute$ } from 'hfty-navigation-web'

// Selectors
import toggled$ from '../selectors/toggled'
import { userlabel$, username$ } from 'fc-authenticated-user'
import selectedSeason$ from 'hfty-seasons/src/selectors/selectedSeason'
import selectedFarm$ from 'hfty-assets/src/selectors/selectedFarm'
import farms$ from 'fc-assets/src/selectors/farms'
import { seasons$ } from 'fc-seasons'

// Actions
import { removeCredentials } from 'fc-auth'
import { updateCurrentSeason } from 'hfty-seasons'
import { updateFarm } from 'hfty-assets'

function mapStateToProps (state: *): * {
  return {
    toggled: toggled$(state),
    userlabel: userlabel$(state),
    activeRoute: activeRoute$(state),
    selectedSeason: selectedSeason$(state),
    selectedFarm: selectedFarm$(state),
    seasons: seasons$(state),
    farms: farms$(state),
    username: username$(state),
  }
}

const mapDispatchToProps = {
  onToggle: toggleMenu,
  logout: removeCredentials,
  onChangeSeason: updateCurrentSeason,
  onChangeFarm: updateFarm,
  push,
}

export default connect(mapStateToProps, mapDispatchToProps)
